import { GetterTree } from 'vuex';
import { FunctionsState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<FunctionsState, RootState> = {
    functionMap(state): any {
        const { functionMap } = state;
        return functionMap;
    },
};
